import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
  ParametrosOrdenamientosEntity,
  ServicioOrdenamientosService,
  FitlrosOrdenEscritaEntity
} from 'src/app/services/servicio-ordenamientos.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-header-orden-escritas',
  templateUrl: './header-orden-escritas.component.html',
  styleUrls: ['./header-orden-escritas.component.css']
})
export class HeaderOrdenEscritasComponent implements OnInit {

  @Input() parametros: ParametrosOrdenamientosEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  filtros: FitlrosOrdenEscritaEntity = {} as FitlrosOrdenEscritaEntity;
  profesionales: SelectItem[] = [];
  profesionalesSelected = [];

  solicitudes: SelectItem[] = [];
  solicitudesSelected = [];

  constructor(private ordenamientosService: ServicioOrdenamientosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }
  ngOnInit() {
    this.getProfesionales();
  }

  async getProfesionales() {
    let response = await this.ordenamientosService.getProfesionalesOrden(this.parametros);

    response.subscribe((data: object) => {
      const profesionales = data['#result-set-1'];
      if (profesionales && profesionales.length > 0) {
        profesionales.forEach((profesional: any) => {
          this.profesionales.push({
            label: profesional['Profesional_Salud'],
            value: profesional['unco']
          });
          this.profesionalesSelected.push(profesional['unco']);
        });
        this.getSolicitudesDisponibles();
      } else {
        this.errorGenerado.emit('Lista de profesionales vacía, verifique que existan registros de órdenes escritas.');
      }
    }, (error) => {
      console.log('Error HeaderOrdenEscritasComponent.getProfesionales()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    })
  }

  async getSolicitudesDisponibles() {
    const profesionales = this.profesionales.map(profesional => profesional.value).toString();
    let response = await this.ordenamientosService.getSolicitudesDisponibles(this.parametros, profesionales);

    response.subscribe((data: object) => {
      const solicitudes = data['#result-set-1'];
      if (solicitudes && solicitudes.length > 0) {
        solicitudes.forEach(solicitud => {
          this.solicitudes.push({
            label: solicitud['dscrpcn_ordn'],
            value: solicitud['unco_om']
          });
          this.solicitudesSelected.push(solicitud['unco_om']);
        });
        this.onGenerar();
      } else {
        this.errorGenerado.emit('Lista de solicitudes vacía, verifique que existan registros de órdenes escritas.');
      }
    }, (error) => {
      console.log('Error HeaderOrdenEscritasComponent.getSolicitudesDisponibles()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de solicitudes médicas, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    })
  }

  onGenerar() {
    if (this.profesionalesSelected.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Profesional</strong>.');
    } else if (this.solicitudesSelected.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos una <strong>Solicitud</strong>.');
    } else {
      this.filtros.profesionales = this.profesionalesSelected;
      this.filtros.solicitudes = this.solicitudesSelected;
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-orden-escritas').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}
